import iframeDialog from './iframe-dialog'

export default {
    install: function(Vue) {
        Vue.component('iframeDialog', iframeDialog)
    }
}